module.exports = __webpack_public_path__ + "img/micro.8fcab167.png";